import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { DateUtils } from '@utils/DateUtils';

@Injectable({
    providedIn: 'root'
})
export class FileService {

    // constructor() { }

    public ExportAsExcelFile<T>(headers: string[], data: string[][], fileName: string): void {

        if (!data || data.length === 0) {
            console.warn('Não há dados para exportar.');
            return;
        }

        // Extrair dinamicamente os headers das chaves do primeiro objeto
        // const headers = Object.keys(data[0]);
        console.log(headers);

        // Converter dados para matriz [ [header1, header2], [linha1col1, linha1col2], ... ]
        const worksheetData = [
            headers, // primeira linha com headers
            ...data //.map(row => headers.map(key => (row as any)[key]))
        ];

        // Criar worksheet
        const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Criar workbook
        const workbook: XLSX.WorkBook = {
            Sheets: { 'Dados': worksheet },
            SheetNames: ['Dados']
        };

        // Gerar buffer binário
        const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });

        // Salvar ficheiro
        this.saveAsExcelFile(excelBuffer, fileName);
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {

        const data: Blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        });

        saveAs(data, `${fileName}_${DateUtils.FormatDate(new Date().toISOString()).replace(/\//g, '-')}.xlsx`);
    }

    /**
     * 
     * @param file 
     * @returns 
     */
    public ReadExcelFile(file: File): Promise<any[][]> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                try {
                    const workbook = XLSX.read(e.target.result, { type: 'array' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const jsonData: any = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // array de arrays
                    resolve(jsonData);
                } catch (error) {
                    reject(error);
                }
            };
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(file);
        });
    }

    /**
     * Verifica se o Excel tem o formato esperado.
     * Parâmetro: dados lidos via XLSX.utils.sheet_to_json(worksheet, { header: 1 })
     * Retorno: objeto com {
     *   isValid: boolean,
     *   errors: string[]
     * }
     */
    public ValidateStructureForMerchantFile(data: any[][]): { isValid: boolean; errors: string[] } {
        debugger

        const errors: string[] = [];
        if (!Array.isArray(data) || data.length < 2) {
            return { isValid: false, errors: ['Faltam pelo menos 2 linhas (cabeçalhos)'] };
        }

        // const headerRow0 = data[0]; // Primeira linha: grupos
        const headerRow1 = data[1]; // Segunda linha: campos específicos

        // // Etapa 1: Verificar grupos esperados na linha 0
        // const expectedGroups = [
        //     'Informação Geral',
        //     'Localidade',
        //     'Contactos',
        //     'Dados do Responsável',
        //     'Observações'
        // ];

        // const actualGroups = this.extractGroups(headerRow0);
        // for (const group of expectedGroups) {
        //     if (!actualGroups.includes(group)) {
        //         errors.push(`Grupo ausente na linha 0: "${group}"`);
        //     }
        // }

        // Etapa 2: Verificar campos principais na linha 1 (subcabeçalhos)
        // Vamos criar um "mapa" dos campos esperados em cada bloco.
        // Exemplo: na linha 1, espera-se:
        // ['Nome', 'Descrição', 'NIF', 'IBAN', 'Nome Fiscal', 'Setor', 'Rua', 'Localidade', ...]
        const expectedFields = [
            'Nome', 'Descrição', 'NIF', 'IBAN', 'Nome Fiscal', 'Setor',
            'Rua', 'Localidade', 'Código Postal', 'Concelho', 'Distrito', 'Latitude', 'Longitude',
            'Telemóvel', 'Telefone', 'Email',
            '', // atenção à quebra de linha
            'Nome', 'NIF', 'Telemóvel', 'Telefone', 'Email', 'Tipo documento', 'Número documento',
            'Validade documento', 'Data nascimento',
            'Observações'
        ];

        // Como os dados são coluna a coluna, vamos comparar elemento a elemento
        const minLen = Math.min(headerRow1.length, expectedFields.length);
        for (let i = 0; i < minLen; i++) {
            const cell = headerRow1[i];
            const expected = expectedFields[i];
            // Trata quebras de linha inconsistentes ou espaços em branco
            const normalizedCell = String(cell ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
            const normalizedExpected = expected.trim().replace(/\s+/g, ' ').toLowerCase();

            if (normalizedCell !== normalizedExpected && !(cell === null && expected.includes('\r\n'))) {
                // Se for null mas esperávamos quebra de linha (ex: CAE), permitimos uma margem de erro
                if (cell === null && expected.includes('\r\n')) {
                    continue;
                }
                errors.push(`Campo inesperado na coluna ${i + 1} (linha 2): esperado "${normalizedExpected}", encontrado "${normalizedCell}"`);
            }
        }

        return {
            isValid: errors.length === 0,
            errors
        };
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    public ValidateStructureForConsumerFile(data: any[][]): { isValid: boolean; errors: string[] } {

        const errors: string[] = [];
        if (!Array.isArray(data) || data.length < 2) {
            return { isValid: false, errors: ['Faltam pelo menos 2 linhas (cabeçalhos)'] };
        }

        // const headerRow0 = data[0]; // Primeira linha: grupos
        const headerRow1 = data[1]; // Segunda linha: campos específicos

        // // Etapa 1: Verificar grupos esperados na linha 0
        // const expectedGroups = [
        //     'Informação Geral',
        //     'Localidade',
        //     'Contactos',
        //     'Dados do Responsável',
        //     'Observações'
        // ];

        // const actualGroups = this.extractGroups(headerRow0);
        // for (const group of expectedGroups) {
        //     if (!actualGroups.includes(group)) {
        //         errors.push(`Grupo ausente na linha 0: "${group}"`);
        //     }
        // }

        // Etapa 2: Verificar campos principais na linha 1 (subcabeçalhos)
        // Vamos criar um "mapa" dos campos esperados em cada bloco.
        // Exemplo: na linha 1, espera-se:
        // ['Nome', 'Descrição', 'NIF', 'IBAN', 'Nome Fiscal', 'Setor', 'Rua', 'Localidade', ...]
        const expectedFields = [
            "Name", "BirthDate", "Document Type", "IdentificationDocumentNumber", "Expire document date", "VatNumber", "SexGender", "Address", "Location", "Postal code", "Phone", "Email"
        ];


        // Como os dados são coluna a coluna, vamos comparar elemento a elemento
        const minLen = Math.min(headerRow1.length, expectedFields.length);
        for (let i = 0; i < minLen; i++) {
            const cell = headerRow1[i];
            const expected = expectedFields[i];
            // Trata quebras de linha inconsistentes ou espaços em branco
            const normalizedCell = String(cell ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
            const normalizedExpected = expected.trim().replace(/\s+/g, ' ').toLowerCase();

            if (normalizedCell !== normalizedExpected && !(cell === null && expected.includes('\r\n'))) {
                // Se for null mas esperávamos quebra de linha (ex: CAE), permitimos uma margem de erro
                if (cell === null && expected.includes('\r\n')) {
                    continue;
                }
                errors.push(`Campo inesperado na coluna ${i + 1} (linha 2): esperado "${normalizedExpected}", encontrado "${normalizedCell}"`);
            }
        }

        return {
            isValid: errors.length === 0,
            errors
        };
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    public ValidateStructureForConsumerHouseHoldersFile(data: any[][]): { isValid: boolean; errors: string[] } {

        const errors: string[] = [];
        if (!Array.isArray(data) || data.length < 1) {
            return { isValid: false, errors: ['Faltam pelo menos 2 linhas (cabeçalhos)'] };
        }

        const headerRow0 = data[0]; // Segunda linha: campos específicos


        // Etapa 2: Verificar campos principais na linha 1 (subcabeçalhos)
        // Vamos criar um "mapa" dos campos esperados em cada bloco.
        // Exemplo: na linha 1, espera-se:
        // ['Nome', 'Descrição', 'NIF', 'IBAN', 'Nome Fiscal', 'Setor', 'Rua', 'Localidade', ...]
        const expectedFields = [
            "USER_ID", "USER_VAT_NUMBER", "NIF_ALUNO", "NOME_ALUNO", "VALOR_APOIO", "FIM_VALIDADE"

            // "Id", "Nome", "Data de Nascimento", "Número do Cartão de Cidadão", "Validade do Cartão de Cidadão", "NIF", "Morada", "Localidade", "Código Postal", "Telemóvel", "Email", "Id", "Nome", "NIF"
        ];


        // Como os dados são coluna a coluna, vamos comparar elemento a elemento
        const minLen = Math.min(headerRow0.length, expectedFields.length);
        for (let i = 0; i < minLen; i++) {
            const cell = headerRow0[i];
            const expected = expectedFields[i];
            // Trata quebras de linha inconsistentes ou espaços em branco
            const normalizedCell = String(cell ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
            const normalizedExpected = expected.trim().replace(/\s+/g, ' ').toLowerCase();

            if (normalizedCell !== normalizedExpected && !(cell === null && expected.includes('\r\n'))) {
                // Se for null mas esperávamos quebra de linha (ex: CAE), permitimos uma margem de erro
                if (cell === null && expected.includes('\r\n')) {
                    continue;
                }
                errors.push(`Campo inesperado na coluna ${i + 1} (linha 2): esperado "${normalizedExpected}", encontrado "${normalizedCell}"`);
            }
        }

        return {
            isValid: errors.length === 0,
            errors
        };
    }
    /**
   * Dada uma linha (array), extrai os "grupos" não nulos e não vazios,
   * ignorando null/undefined/strings em branco.
   */
    private extractGroups(row: any[]): string[] {
        return row
            .filter(c => c !== null && typeof c === 'string' && c.trim() !== '')
            .map(c => c.trim());
    }


    /**
     * Lê um ficheiro XML e converte-o em JSON.
     * Usa DOMParser para parsear e converte recursivamente para objeto JS.
     */
    public ReadXMLFile(file: File): Promise<any> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                try {
                    const xmlContent = e.target.result;
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(xmlContent, 'text/xml');
                    const json = this.xmlToJson(xmlDoc.documentElement);
                    resolve(json);
                } catch (error: any) {
                    reject(error);
                }
            };
            reader.onerror = (error) => reject(error);
            reader.readAsText(file);
        });
    }

    /**
     * Converte nó XML recursivamente para objeto JavaScript.
     */
    private xmlToJson(xml: Element): any {
        const obj: any = {};
        if (xml.attributes && xml.attributes.length > 0) {
            obj['@attributes'] = {};
            for (let i = 0; i < xml.attributes.length; i++) {
                const attr = xml.attributes[i];
                obj['@attributes'][attr.name] = attr.value;
            }
        }

        if (xml.children.length === 0 && xml.textContent?.trim() !== '') {
            return xml.textContent?.trim();
        }

        for (let i = 0; i < xml.children.length; i++) {
            const child = xml.children[i] as Element;
            const childName = child.localName || child.nodeName;
            const childObj = this.xmlToJson(child);

            if (obj[childName]) {
                if (!Array.isArray(obj[childName])) {
                    obj[childName] = [obj[childName]];
                }
                obj[childName].push(childObj);
            } else {
                obj[childName] = childObj;
            }
        }

        return obj;
    }
}
